export const LOCALE_COOKIE = 'exp_locale';
export const REFERRAL_COOKIE = 'exp_referral';
export const CURRENCY_COOKIE = 'exp_currency';
export const COUNTRY_COOKIE = 'exp_country';
export const COOKIES_PRIVACY = 'exp_privacy';
